import LoginInfoCard from "./login-info-card";

export default LoginInfoCard;
